<template>
  <transition name="fade">
    <div v-if="show" class="wizard">
      <div class="closeIcon" @click="show = false">
        <dotcom-icon
          name="xmark"
          art="light"
          color="--c-secondary-neutral-2"
          hover-color="--c-primary-neutral-3"
        />
      </div>
      <div class="wizard-container container sanitas-contact-wizard">
        <wizard-breadcrumb
          class="wizard-breadcrumb"
          :links="breadcrumbRoutes"
          :back-label="backLabel"
        />
        <wizard-card
          v-if="$route.path === '/'"
          :title="parseJson(wizard).title"
          :intro="parseJson(wizard).pageDescription"
          :topics="parseJson(wizard).items"
          @cardClicked="topicClicked"
        ></wizard-card>
        <div v-else-if="selectedItem">
          <wizard-card
            v-if="isTeaser(selectedItem)"
            :title="selectedItem.pageTitle"
            :intro="selectedItem.pageDescription"
            :topics="selectedItem.items"
            @cardClicked="topicClicked"
          ></wizard-card>
          <wizard-form
            v-else
            :teaser="parseJson(teaser)"
            :triage-full="parseJson(triageFull)"
            :triage-basic="parseJson(triageBasic)"
            :active="$route.path === selectedItem.slug"
            :item="selectedItem"
          ></wizard-form>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import WizardBreadcrumb from './components/WizardBreadcrumb'
import WizardCard from './components/WizardCard'
import WizardForm from './components/WizardForm'

export default {
  name: 'SanitasContactWizardModule',

  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
    WizardCard,
    WizardBreadcrumb,
    WizardForm,
  },

  props: {
    backLabel: {
      type: String,
      default: 'Back',
    },
    breadcrumbRootLabel: {
      type: String,
      default: 'Themes',
    },
    wizard: {
      type: String,
      default: '{}',
    },

    triageFull: {
      type: String,
      default: '{}',
    },

    triageBasic: {
      type: String,
      default: '{}',
    },

    teaser: {
      type: String,
      default: '{}',
    },
  },
  data: () => ({
    flattenItems: [],
    show: false,
  }),
  computed: {
    breadcrumbRoutes() {
      const { $route, breadcrumbRootLabel, flattenItems } = this
      const { path } = $route
      const items = path.split('/').filter(slug => !!slug)
      const links = [{ label: breadcrumbRootLabel, path: '/' }].concat(
        items.map(function (id) {
          const topic = flattenItems.filter(item => item.id === id)[0]
          return {
            label: topic.title,
            path: topic.slug !== path ? topic.slug : undefined,
          }
        }),
      )
      if (links.length === 1) {
        links[0].path = undefined
      }

      return links
    },
    selectedItem() {
      const { path } = this.$route
      return this.flattenItems.find(it => it.slug === path)
    },
  },
  watch: {
    wizard: {
      handler(wizard) {
        this.flattenItems = this.extractor(this.parseJson(wizard)).slice(1)
      },
      immediate: true,
    },
    show: {
      handler(value) {
        if (!value) {
          this.$router.push('/')
          document.body.style.overflow = 'auto'
        } else {
          document.body.style.overflow = 'hidden'
        }
      },
    },
  },
  created() {
    window.addEventListener('sanitas-open-contact-wizard', () => {
      this.show = true
    })
  },
  methods: {
    parseJson(string) {
      return JSON.parse(string)
    },
    extractor(item, slug) {
      slug = item.id ? (slug || '') + '/' + item.id : slug || ''
      let results = [
        Object.assign(item, {
          slug: slug,
          teaser: !!item.items && item.items.length > 0,
        }),
      ]
      if (item.items) {
        results = item.items.reduce(
          (acc, subitem) => acc.concat(this.extractor(subitem, slug)),
          results,
        )
      }
      return results
    },
    topicClicked(topic) {
      let slug = topic.slug
      if (this.$route.path === '/') {
        slug = topic.id ? (slug || '') + '/' + topic.id : slug || ''
      }
      this.$router.push(slug)
    },
    isTeaser(item) {
      return item.teaser || (!!item.items && item.items.length > 0)
    },
  },
}
</script>

<style lang="postcss" scoped>
.wizard {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  height: 100%;
  z-index: 1000;
  padding: 25px;
  background-color: var(--c-primary-color-1);
  overflow-y: auto;
  .closeIcon {
    position: absolute;
    right: var(--spacing-2);
    top: var(--spacing-2);
    cursor: pointer;
    padding: var(--spacing-2);

    & >>> .dotcom-icon {
      width: 20px;
      height: 20px;
    }
  }
  &-breadcrumb {
    &.scrolled:before {
      color: red;
      position: absolute;
      left: 0;
      height: 30px;
      width: 100%;
      content: '';
      background: linear-gradient(
        to right,
        rgba(0, 118, 90, 1) 5%,
        rgba(0, 118, 90, 0) 20%
      );
      pointer-events: none; /* so the text is still selectable */
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
